import { z } from 'zod';

/**
 * State schemas
 */
export const CreateStateSchema = z.object({
  name: z.string().min(2, 'State name must be at least 2 characters'),
  code: z.string().min(2, 'State code must be at least 2 characters').max(3, 'State code must be at most 3 characters'),
  displayOrder: z.number().int().min(0).default(999).optional(),
  isActive: z.boolean().default(true).optional(),
});

export type CreateStateRequest = z.infer<typeof CreateStateSchema>;

export const UpdateStateSchema = z.object({
  name: z.string().min(2).optional(),
  code: z.string().min(2).max(3).optional(),
  displayOrder: z.number().int().min(0).optional(),
  isActive: z.boolean().optional(),
});

export type UpdateStateRequest = z.infer<typeof UpdateStateSchema>;

/**
 * City schemas
 */
export const CreateCitySchema = z.object({
  name: z.string().min(2, 'City name must be at least 2 characters'),
  stateId: z.string().uuid('Invalid state ID'),
  servicePincodes: z.string().optional(),
  isPopular: z.boolean().default(false).optional(),
  displayOrder: z.number().int().min(0).default(999).optional(),
  latitude: z.number().min(-90).max(90).optional(),
  longitude: z.number().min(-180).max(180).optional(),
  isActive: z.boolean().default(true).optional(),
});

export type CreateCityRequest = z.infer<typeof CreateCitySchema>;

export const UpdateCitySchema = z.object({
  name: z.string().min(2).optional(),
  servicePincodes: z.string().optional(),
  isPopular: z.boolean().optional(),
  displayOrder: z.number().int().min(0).optional(),
  latitude: z.number().min(-90).max(90).optional(),
  longitude: z.number().min(-180).max(180).optional(),
  isActive: z.boolean().optional(),
});

export type UpdateCityRequest = z.infer<typeof UpdateCitySchema>;

/**
 * Response types
 */
export interface StateResponse {
  id: string;
  name: string;
  code: string;
  displayOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  cities?: CityResponse[];
}

export interface CityResponse {
  id: string;
  name: string;
  slug: string;
  stateId: string;
  servicePincodes: string | null;
  isPopular: boolean;
  displayOrder: number;
  latitude: number | null;
  longitude: number | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  state?: StateResponse;
}
